import React, { Component } from "react";
import PropTypes from "prop-types";

export default class ArchiveCheckboxGroupFilter extends Component {
    constructor(props) {
        super(props);
    }

    renderClasses() {
        const classes = `filter__container filter__checkbox-group`;

        return this.props.options.length > 5
            ? classes + " filter__container--scroll"
            : classes;
    }

    renderOptions() {
        if (this.props.options.length === 0) {
            return null;
        }

        return this.props.options.map(option => {
            return (
                <li className="filter__option-wrapper" key={option.value}>
                    <input
                        type="checkbox"
                        role="checkbox"
                        aria-checked="false"
                        className={`filter__field ${
                            this.props.value.includes(option.value)
                                ? "checked"
                                : ""
                        }`}
                        id={option.value}
                        name="search"
                        defaultChecked={this.props.value.includes(option.value)}
                        value={option.value}
                        onChange={e => this.props.onChanged(e)}
                    />
                    <label htmlFor={option.value}>{option.name.replace("&amp;", "&")}</label>
                </li>
            );
        });
    }

    render() {
        if (this.props.options.length === 0) {
            return null;
        }

        return (
            <section className="filter">
                <h4 className="filter__title">{this.props.title}</h4>
                <form className={this.renderClasses()} method="get">
                    <ul className="filter__option-list">
                        {this.renderOptions()}
                    </ul>
                </form>
            </section>
        );
    }
}

ArchiveCheckboxGroupFilter.props = {
    options: PropTypes.array,
    title: PropTypes.string,
    value: PropTypes.array
};

export class CheckboxOption {
    value;
    name;
    checked;

    constructor(value, name, checked) {
        (this.value = value),
            (this.name = name),
            (this.checked = checked || false);
    }
}
